import { abyssColors, primary } from '@/theme/colors';
import { alpha, styled as muiStyled } from '@mui/material/styles';
import { Button, Card, Chip } from '@mui/material';
import styled from 'styled-components';

export const TabPill = muiStyled(Button)(({ selected }: { selected: boolean }) => ({
  whiteSpace: 'nowrap',
  fontSize: '1.3rem',
  boxShadow: 'none',
  height: '32px',
  borderRadius: '32px',
  padding: '8px 10px',
  display: 'flex',
  alignItems: 'center',
  textTransform: 'none',
  fontWeight: '400',
  backgroundColor: selected ? abyssColors.primary[600] : alpha(primary.light, 0.2),
  color: selected ? abyssColors.neutral[50] : 'black',
  '&:hover': { backgroundColor: selected ? abyssColors.primary[600] : alpha(primary.light, 0.2) },
}));

export const StructureCardContainer = muiStyled(Card)({
  border: '1px solid #E7EEF6',
  borderRadius: '12px',
  padding: '16px',
  height: 300,
  width: 300,
  textAlign: 'center',
  cursor: 'pointer',
});

export const StructureImg = muiStyled('div')({
  width: '100%',
  minHeight: 150,
  borderRadius: '10px',
  marginBottom: '14px',
  overflow: 'hidden',
});

export const tooltipStyles = {
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#000000B8',
    color: abyssColors.primary[50],
    opacity: 1,
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  '& .MuiTooltip-arrow': {
    color: '#000000B8',
  },
};

export const AdditionalOptions = styled.span`
  line-height: normal;
  font-size: 1rem;
  margin-right: 10px;
  cursor: pointer;
`;

export const OptionChip = muiStyled(Chip)(() => ({
  lineHeight: 'normal',
  fontSize: '1rem',
  background: abyssColors.primary[100],
  color: abyssColors.primary[500],
  height: '24px',
  borderRadius: '16px',
  '& .MuiChip-label': {
    paddingLeft: '10px',
    paddingRight: '10px',
    marginBottom: '-1px',
  },
  '& .MuiChip-deleteIcon': { color: abyssColors.primary[300], fontSize: '1.6rem' },
}));
